import React from "react";

export default function MSAccess_LTrim() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_LTrim</h1>
      <p>This is the MSAccess_LTrim component generated from the SQL JSON.</p>
    </div>
  );
}
